import styled from 'styled-components';
import { rem } from 'polished';

export const Section = styled.section`
  padding: ${rem('80px')} 0;
  background: #111827;
  color: #ffffff;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    padding: ${rem('60px')} 0;
  }
`;

export const Container = styled.div`
  margin: 0 auto;
  padding: 0 ${rem('16px')};
  width: 100%;
  box-sizing: border-box;

  @media ${({ theme }) => theme.mediaQueries.large} {
    max-width: ${rem('1190px')};
  }

  @media ${({ theme }) => theme.mediaQueries.largeMax} {
    max-width: 95%;
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${rem('60px')};
  align-items: center;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    grid-template-columns: 1fr;
    gap: ${rem('40px')};
    text-align: center;
  }
`;

export const Item = styled.div``;

export const Title = styled.h2`
  font-family: 'MontserratBlack', sans-serif;
  color: #ffffff;
  margin-bottom: ${rem('20px')};
  font-size: clamp(1.8rem, 4vw, 2.8rem);
  line-height: 1.3;
  letter-spacing: -0.5px;
  font-weight: 800;
  word-wrap: break-word;
  overflow-wrap: break-word;

  @media ${({ theme }) => theme.mediaQueries.largeMax} {
    justify-self: flex-start;
  }

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    justify-self: center;
    margin-bottom: 0;
    text-align: center;
  }

  @media ${({ theme }) => theme.mediaQueries.large} {
    min-width: 70%;
  }
`;

export const Subtitle = styled.p`
  font-size: ${rem('18px')};
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  margin-bottom: ${rem('30px')};
  max-width: 500px;

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    text-align: center;
    margin: 0 auto ${rem('30px')};
  }
`;

export const IconGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  place-items: center;
  gap: ${rem('40px')} ${rem('20px')};
  grid-column: 1/2;
  grid-row: 1/3;

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    grid-column: 1/2;
    grid-row: 2/3;
  }

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }
`;

export const Icon = styled.img`
  height: ${rem('50px')};
`;

export const TechGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${rem('16px')};

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    grid-template-columns: repeat(2, 1fr);
    gap: ${rem('14px')};
  }

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    grid-template-columns: 1fr;
    gap: ${rem('16px')};
  }
`;

export const TechCard = styled.div`
  display: flex;
  align-items: center;
  padding: ${rem('14px')};
  background: #000000;
  border-radius: 12px;
  border: 1px solid #333333;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  min-height: ${rem('80px')};

  &:hover {
    background: #1a1a1a;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    padding: ${rem('16px')};
    min-height: ${rem('90px')};
  }
`;

export const TechIcon = styled.div`
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${rem('14px')};
  flex-shrink: 0;

  img {
    max-width: 40px;
    max-height: 40px;
    object-fit: contain;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.1);
  }

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    width: 48px;
    height: 48px;
    margin-right: ${rem('16px')};

    img {
      max-width: 44px;
      max-height: 44px;
    }
  }
`;

export const TechLabel = styled.div`
  flex: 1;

  h3 {
    color: #ffffff;
    font-size: ${rem('15px')};
    font-weight: 600;
    margin: 0;
    line-height: 1.3;

    @media ${({ theme }) => theme.mediaQueries.smallMax} {
      font-size: ${rem('16px')};
    }
  }
`;
